/** Parses a date string (epoch-ms timestamp or natural language) and formats it as e.g. "Mar 11, 2026". */
export function formatOrderDate(dateString: string): string {
  const timestamp = parseInt(dateString, 10);
  const date = Number.isNaN(timestamp) ? new Date(dateString) : new Date(timestamp);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}
